import client from "./axios";

const weatherAPIBaseUrl = `https://internal-api.getmoveapp.com/api/v1/admin/structures/get-weather-data`;

export const Weather = {
  getWeatherInfos: () =>
    client.get(`${weatherAPIBaseUrl}`),
};
